/**
 * Null SPS Provider - no-op implementation
 */
export class NullSpsProvider {
    init() { }
    end() { }
    leseVonSPS(..._args) { return null; }
    sendeAnSPS(..._args) { return null; }
    leseVakWerte(..._args) { return null; }
}
//# sourceMappingURL=sps.js.map